import React, { FormEvent, useContext, useEffect, useState } from 'react';
import { Bitrix24Consumer, Bitrix24Context } from 'contexts/legacy/Bitrix24Context';
import '../../styles/insightsForm.css';
import PhoneInput from 'react-phone-input-2';
import { Button, Icon, Input, Spin } from 'antd';
import 'react-phone-input-2/lib/style.css';
import { api } from 'services/api';
import { LanguageConsumer } from 'contexts/legacy/LanguageContext';
import { FormattedMessage } from 'react-intl';
import { LanguageContext } from 'contexts/LanguageContext';

export function InsightsForm() {
  const [whatsappPhone, setWhatsappPhone] = useState<string>();
  const [formSubmitted, setFormSubmitted] = useState(false);
  const [formAlreadySubmitted, setFormAlreadySubmitted] = useState(false);
  const [errorSubmitting, setErrorSubmitting] = useState(false);
  const [isSubmiting, setIsSubmitting] = useState(false);
  const [auth, setAuth] = useState();
  const [domain, setDomain] = useState<string>();
  const { dictionary } = useContext(LanguageContext);
  const bitrix24 = useContext(Bitrix24Context);

  useEffect(() => {
    if (!bitrix24.infos.domain) {
      return;
    }

    const auth = bitrix24.infos.auth;
    const domain = bitrix24.infos.domain;
    setDomain(domain);
    setAuth(auth);
  }, [bitrix24.infos.auth, bitrix24.infos.domain]);

  useEffect(() => {
    const inputs = document.querySelectorAll<HTMLInputElement>('.form input');
    inputs.forEach((input) => {
      input.addEventListener('invalid', () => {
        input.setCustomValidity('');
        if (!input.validity.valid) {
          input.setCustomValidity(dictionary.insight_form_required_field);
        }
      });

      input.addEventListener('input', () => {
        input.setCustomValidity('');
      });
    });

    return () => {
      inputs.forEach((input) => {
        input.removeEventListener('invalid', () => {});
        input.removeEventListener('input', () => {});
      });
    };
  }, []);

  const handleFormSubmit = async (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    setIsSubmitting(true);
    const formData = new FormData(event.currentTarget);
    if (domain && auth) {
      formData.append('domain', domain);
      formData.append('auth', auth);
    }

    try {
      const { data } = await api.post('features/create-insights-lead', formData);

      if (data === 'interest already registered') {
        setFormAlreadySubmitted(true);
        return;
      }

      setFormSubmitted(true);
      setIsSubmitting(false);
    } catch (error) {
      setIsSubmitting(false);
      setErrorSubmitting(true);
    }
  };

  if (formAlreadySubmitted) {
    return (
      <div className="formModal">
        <h1 className="formTitle">
          <FormattedMessage id="insight_form_already_submitted_title" />
        </h1>

        <h2 className="formSubtitle">
          <FormattedMessage id="insight_form_already_submitted_subtitle" />
        </h2>
        <div className="formIconContainer">
          {/* 
        // @ts-ignore */}
          <Icon type="check-circle" theme="filled" style={{ fontSize: 'xxx-large', color: '#B1D34A' }} />
        </div>
      </div>
    );
  }

  if (errorSubmitting) {
    return (
      <div className="formModal">
        <h1 className="formTitle">
          <FormattedMessage id="insight_form_error_title" />
        </h1>
        <h2 className="formSubtitle">
          <FormattedMessage id="insight_form_error_subtitle" />
        </h2>
        <p className="formMessage">
          <FormattedMessage id="insight_form_error_message" />
        </p>
        <div className="formIconContainer">
          {/* 
        // @ts-ignore */}
          <Icon type="close-circle" theme="filled" style={{ fontSize: 'xxx-large', color: '#FF0D21' }} />
        </div>
      </div>
    );
  }

  if (formSubmitted) {
    return (
      <div className="formModal">
        <h1 className="formTitle">
          <FormattedMessage id="insight_form_success_title" />
        </h1>

        <h2 className="formSubtitle">
          <FormattedMessage id="insight_form_success_subtitle" />
        </h2>
        <p className="formMessage">
          <FormattedMessage id="insight_form_success_message" />
        </p>
        <div className="formIconContainer">
          {/* 
        // @ts-ignore */}
          <Icon type="check-circle" theme="filled" style={{ fontSize: 'xxx-large', color: '#B1D34A' }} />
        </div>
      </div>
    );
  }

  return (
    <div className="formModal">
      <form onSubmit={handleFormSubmit} className="form">
        <div>
          <h1 className="formTitle">
            <FormattedMessage id="insight_form_title" />
          </h1>
          <h2 className="formSubtitle">
            <FormattedMessage id="insight_form_subtitle" />
          </h2>
          <p className="formMessage">
            <FormattedMessage id="insight_form_message" />
          </p>
          <div className="formInput">
            <label htmlFor="name">
              <FormattedMessage id="insight_form_name" />
              <Input type="text" id="name" name="name" required={true} className="formInput" />
            </label>
          </div>
          <div className="formInput">
            <label htmlFor="email">
              <FormattedMessage id="insight_form_email" />
              <Input type="email" id="email" name="email" required={true} className="formInput" />
            </label>
          </div>
          <div className="formInput">
            <label htmlFor="phone">
              <FormattedMessage id="insight_form_whatsapp" />
              <PhoneInput
                value={whatsappPhone}
                country={'br'}
                preferredCountries={['br']}
                autoFormat={true}
                enableSearch={true}
                disableSearchIcon={true}
                onChange={(value) => setWhatsappPhone(value)}
                disableDropdown={false}
                inputProps={{
                  name: 'phone',
                  required: true,
                  style: {
                    width: '100%',
                  },
                }}
              />
            </label>
          </div>
          <div className="formButtonContainer">
            <Button type="primary" size="large" htmlType="submit" className="formButton">
              {isSubmiting ? (
                <Spin style={{ color: 'white' }} size="small" />
              ) : (
                <FormattedMessage id="insight_form_send" />
              )}
            </Button>
          </div>
        </div>
      </form>
    </div>
  );
}

export default LanguageConsumer(Bitrix24Consumer(InsightsForm));
